<nz-form-control>
  <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
    <input nz-input [(ngModel)]="recordProperty.ValueAsObject" #attachmentInput readonly hidden />
    <input nz-input [value]="attachmentInput.value | attachmentSlice" type="text" readonly />
  </nz-input-group>

  <div *ngIf="field.AdditionalInformationParsed.IsImage && recordProperty.ValueAsObject !== ''"
    style="padding-top: 15px;">
    <img style="width: 100%"
      [src]="baseUrl + 'media/PreviewFile?path=' + recordProperty.ValueAsObject + '&' + urlSuffix" />
  </div>
  <ng-template #suffixIconButton>
    <nz-button-group *ngIf="!recordProperty.ReadOnly">
      <button *ngIf="recordProperty.ValueAsObject !== ''" nz-button nzType="default" nzSearch (click)="clearAttachment();">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </button>
      <button nz-button nzType="default" nzSearch (click)="preview();">
        <i nz-icon nzType="eye" nzTheme="outline"></i>
      </button>
      <button nz-button nzType="default" nzSearch (click)="isAttachmentDrawerVisible = true;">
        <i nz-icon nzType="upload" nzTheme="outline"></i>
      </button>
    </nz-button-group>
    <nz-button-group *ngIf="recordProperty.ReadOnly">
      <button nz-button nzType="default" nzSearch (click)="preview();">
        <i nz-icon nzType="eye" nzTheme="outline"></i>
      </button>
    </nz-button-group>
  </ng-template>
</nz-form-control>
<nz-drawer #mediaDrawer nzPlacement="bottom" [nzTitle]="'Choose Media' | locale" nzHeight="650px"
  [nzVisible]="isAttachmentDrawerVisible" (nzOnClose)="isAttachmentDrawerVisible = false">
  <app-media-container [isImage]="field.AdditionalInformationParsed.IsImage"
  [allowUploadFile]="field.AdditionalInformationParsed.AllowUploadFile"
                  [allowSignature]="field.AdditionalInformationParsed.AllowSignature"
                  [allowUsingCamera]="field.AdditionalInformationParsed.AllowUsingCamera"
                  *ngIf="isAttachmentDrawerVisible"
    (fileUploaded)="recordProperty.ValueAsObject = $event; valueChanged(); isAttachmentDrawerVisible = false;">
  </app-media-container>
</nz-drawer>
